import { render, staticRenderFns } from "./disabledMode-editor.vue?vue&type=template&id=063ae02f&scoped=true&"
import script from "./disabledMode-editor.vue?vue&type=script&lang=js&"
export * from "./disabledMode-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063ae02f",
  null
  
)

export default component.exports